import { ISODate } from '../../../common/utils';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { DataObjectDescriptionVersionUrl } from '../../query/DataObjectDescriptionVersionUrl';

type ValidateDeadlinesQueryParams = {
  dataObjectVersionId: number;
  period: [ISODate, ISODate];
};

const validateDeadlines = ({
  dataObjectVersionId,
  period,
}: ValidateDeadlinesQueryParams) =>
  apiClient
    .post<void>(
      expand(DataObjectDescriptionVersionUrl.validateDeadlines, {
        id: dataObjectVersionId,
      }),
      { from: period[0], to: period[1] },
    )
    .then((response) => response.data);

export const useValidateDeadlines = createApiMutationHook(
  ['validate-deadlines'],
  validateDeadlines,
);
